import {Sprite, Text, Block, Callback, Variable, Operator, BooleanBlock, NumberBlock} from "../index";
import {GRAMMAR, STATE} from "../../Type";
import Line from "../../Line";

export class Util extends Block {
  get type() {
    return "Util";
  }

  get category() {
    return "Util";
  }

  getGrammarFor(parent) {
    switch (this.data) {
      case "if":
      case "else if":
      case "repeat":
      case "else":
        return GRAMMAR.PHRASE;
      case "clone":
        return parent.grammar;
      default:
        return GRAMMAR.SUBJECT;
    }
  }

  getDefaultChildren() {
    switch (this.data) {
      case "if":
      case "else if":
      case "repeat":
        return [new Block({state: STATE.INSTANCE, parent: this}), new Callback({state: STATE.INSTANCE, parent: this})];
      case "else":
        return [new Callback({state: STATE.INSTANCE, parent: this})];
      case "clone":
        if (this.grammar === GRAMMAR.SUBJECT) {
          return [new Block({state: STATE.INSTANCE, parent: this})];
        } else {
          return [];
        }
      default:
        return [];
    }
  }

  static getPrototypeBlocks() {
    const prototypeBlocks = [
      new Util({data: "if", state: STATE.PROTOTYPE}),
      new Util({data: "else if", state: STATE.PROTOTYPE}),
      new Util({data: "else", state: STATE.PROTOTYPE}),
      new Util({data: "repeat", state: STATE.PROTOTYPE}),
      new Util({data: "clone", state: STATE.PROTOTYPE}),
      // ...Mobile.getPrototypeBlocks(),
      // ...Ranking.getPrototypeBlocks(),
      // ...Timer.getPrototypeBlocks()
    ];
    return prototypeBlocks;
  }

  isAvailableParentFor(block) {
    if (this.data !== "clone") {
      return super.isAvailableParentFor(block);
    }

    if (block instanceof Util && block.data === "clone") {
      return false;
    }

    const availableParentTypes = block.getAvailableParentTypes();
    for (let i in availableParentTypes) {
      if (this.parent instanceof availableParentTypes[i]) {
        return true;
      }
    }

    return false;
  }

  getAvailableChildTypesAt(index) {
    switch (this.data) {
      case "if":
      case "else if":
        return [[BooleanBlock, Variable, Operator], [Callback]][index] || [];
      case "repeat":
        return [[NumberBlock, Variable, Operator], [Callback]][index] || [];
      case "else":
        return [Callback];
      case "clone":
        return this.parent.getAvailableChildTypesAt(index);
      default:
        return [];
    }
  }

  getFinalChildTypesAt(index) {
    switch (this.data) {
      case "if":
      case "else if":
        return [[BooleanBlock], [Callback]][index] || [];
      case "repeat":
        return [[NumberBlock], [Callback]][index] || [];
      default:
        return this.getAvailableChildTypesAt(index);
    }
  }

  getAvailableParentTypes() {
    switch (this.data) {
      case "if":
      case "else if":
      case "repeat":
      case "else":
        return [Line];
      case "clone":
        return [Sprite, Text];
      default:
        return [];
    }
  }

  toJavascript() {
    switch (this.data) {
      case "repeat":
        return this.toJavascriptForRepeat();
      case "if":
      case "else if":
        return this.toJavascriptForIf();
      case "else":
        return this.toJavascriptForElse();
      case "clone":
        return this.toJavascriptForClone();
      default:
        return;
    }
  }

  toJavascriptForRepeat() {
    const repeat = this.children[0].toJavascript();
    const statement = this.linesToJavascript(this.children[1].children);
    return `for(let i = 0; i < ${repeat}; i++) {\n${statement}\n}`;
  }

  toJavascriptForIf() {
    const condition = this.children[0].toJavascript();
    const statement = this.linesToJavascript(this.children[1].children);
    return `${this.data}(${condition}) {\n${statement}\n}`;
  }

  toJavascriptForElse() {
    const statement = this.linesToJavascript(this.children[0].children);
    return `else {\n${statement}\n}`;
  }

  toJavascriptForClone() {
    const child = this.children && this.children[0];

    if (child) {
      const childCode = child.toJavascript();
      return `.clone()${childCode}`;
    }

    return `.clone()`;
  }
}
